import React from 'react';

const Login = () => {
  return (
    <div className="login-page" id="login">
      <div className="login-form">

      </div>
    </div>
  );
}

export default Login;
